module.exports = __webpack_public_path__ + "static/media/news_sloboda.d977ebc2.png";